<template>
  <div>
    <van-nav-bar
      title="注册"
      left-arrow
      @click-left="$router.push('/clogin')"
    />
    <van-steps :active="2">
      <van-step>输入注册信息</van-step>
      <van-step>点击"获取验证码"</van-step>
      <van-step>点击"注册"</van-step>
    </van-steps>
    <van-form validate-first @submit="handleRegClient">
      <van-col :span="24">
        <base-textarea v-model="form.name" size="large" label="企业全称"
                       :show-word-limit="false"
                       :rules="[{ required: true, message: '请输入您的企业全称' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.mobile" type="digit" size="large" label="手机号"
                    maxlength="11" :rules="[{ required: true, message: '请输入手机号' }]"
        />
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.code" type="digit" size="large" label="短信验证码"
                    maxlength="6" :rules="[{ validator: validSms, message: '您输入的短信验证码有误' }]"
        >
          <template #button>
            <van-button size="small" type="primary" :disabled="!isRegInfoValid"
                        @click="handleSendSms">{{ countdownMsg }}</van-button>
          </template>
        </base-input>
      </van-col>
      <van-col :span="24">
        <base-input v-model="form.password" type="password" size="large" label="登录密码"
                    minlength="6" :rules="[{ required: true, message: '请输入登录密码' }]"
        />
      </van-col>
      <van-col :span="24" style="text-align: center;">
        <div style="color: #ccc; font-size: 0.8rem;">
          如您在御茶膳房登记的手机号有变更，请及时联系客服人员！
        </div>
      </van-col>
      <van-col :span="22" :offset="1">
        <br>
        <base-button size="large" native-type="submit" :round="true"
                     :disabled="!isFormValid">注 册</base-button>
      </van-col>
    </van-form>
  </div>
</template>

<script>
import { sendSmsOfClientTerm, registerOfClientTerm } from '@/api/settings/client'
export default {
  data() {
    return {
      form: {
        name: '',
        mobile: '',
        code: '',
        password: ''
      },
      countdown: this.CONST.SEND_SMS_INTERVAL,
      countdownMsg: '获取验证码'
    }
  },
  computed: {
    isRegInfoValid() {
      return this.form.name && this.form.name.length >= 2 &&
        this.form.mobile.length === 11 &&
        this.countdownMsg === '获取验证码'
    },
    isFormValid() {
      return this.form.name.length >= 2 && this.form.mobile.length === 11 &&
        this.form.code.length === 6 && this.form.password.length >= 6
    }
  },
  methods: {
    validSms(val) {
      return /\d{6}/.test(val)
    },
    handleSendSms() {
      sendSmsOfClientTerm({
        name: this.form.name.trim(),
        mobile: this.form.mobile
      }).then(() => {
        this.alert(`验证码已发送至 ${this.form.mobile}`)
        const timer = setInterval(() => {
          if (this.countdown === 0) {
            clearInterval(timer)
            this.countdown = this.CONST.SEND_SMS_INTERVAL
            this.countdownMsg = '获取验证码'
          } else {
            this.countdownMsg = `重新发送(${this.countdown})`
            this.countdown = this.countdown - 1
          }
        }, 1000)
      })
    },
    handleRegClient() {
      if (!this.form.name.trim()) {
        this.error('请输入企业全称')
        return
      }
      if (!this.form.mobile || this.form.mobile.length !== 11) {
        this.error('请输入手机号')
        return
      }
      if (!this.form.code || this.form.code.length !== 6) {
        this.error('请输入短信验证码')
        return
      }
      if (!this.form.password || this.form.password.length < 6) {
        this.error('请输入登录密码')
        return
      }
      registerOfClientTerm(this.form).then(resp => {
        if (resp.success) {
          this.alert(resp.msg)
          // this.$router.push('/home')
        } else {
          this.alert(resp.msg)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client/client-register.vue